// Pure path predicates, in a deliberately dependency-free leaf module.
//
// adminUtil.tsx re-exports these (that is where most of the app reads them from), but the
// definitions have to live here. adminUtil pulls in errorUtil -> Main -> routes -> App ->
// the store reducers, and regionReducers.ts / productLineReducers.ts call these at
// MODULE-INIT time to pick a localStorage key. Importing them from adminUtil made the
// reducer module evaluate while adminUtil was still initialising under some Jest
// entrypoints, so `isGeoTraxPage` was `undefined` and whole admin suites died with
// "isGeoTraxPage is not a function". The reducers therefore import this leaf directly.
//
// Nothing here may import from elsewhere in the app.
export const isAdminPage = (path?: string): boolean =>
  !!path && path.replace(/^\//, '').startsWith('admin');

export const isGeoTraxPage = (path?: string): boolean =>
  !!path && path.replace(/^\//, '').startsWith('geotrax');
